<template>
  <v-form v-if="this.user != ''">
    <v-card color="orange darken-2" dark class="mx-auto my-8">
      <v-card-title>
        This page is for experts to label target species</v-card-title
      >
      <v-card-subtitle> Use Chrome Browser on Desktop</v-card-subtitle>
      <v-btn class="mx-8 my-8" @click="getStats" color="#385F73"
        >Summary Stats By Species</v-btn
      >

      <v-overflow-btn
        class="my-2"
        :items="dropdown_class"
        label="Select Label"
        v-model="labelSearch"
        hint="Label to Query"
      ></v-overflow-btn>
      <v-data-table
        dense
        :headers="tableHeaders"
        :items="labelTable"
        item-key="name"
        class="elevation-1"
      >
        <!-- <template slot="body.append">
                <tr class="yellow--text">
                    <th class="title">Totals</th>
                    <td  v-for="bird in targetList" :key="bird">
                    <th class="title">{{ sumField(bird) }}</th>
                    </td>
                </tr>
            </template> -->
      </v-data-table>
      <!-- <v-btn
            class="mx-8 my-8" 
              @click="getFalseDetectionStats"
              color="#385F73"
              >Get False Detection Stats</v-btn
            >
            <v-data-table
              dense
              :headers="falseDetectionHeaders"
              :items="falseDetectionTable"
              item-key="name"
              class="elevation-1"
              >
              <template slot="body.append">
                <tr class="yellow--text">
                    <th class="title">Totals</th>
                    <td  v-for="label in dropdown_class" :key="label">
                    <th class="title">{{ sumFalseDetection(label) }}</th>
                    </td>
                </tr>
            </template>
            </v-data-table> -->
    </v-card>
    <!-- <v-card
      color="blue-grey darken-2"
      dark
      class="mx-auto my-8"
      max-width="100%"
    >
      <v-card-title> Haikubox: {{ haikuboxName }}</v-card-title>

      <v-overflow-btn
        @change="selectHaikubox(haikubox)"
        class="my-2"
        :items="haikuboxList"
        label="Select Haikubox"
        v-model="haikubox"
      ></v-overflow-btn>
    </v-card> -->
    <!-- <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>Top detections</v-expansion-panel-header>
              <v-expansion-panel-content>
            <v-list dense>
              <v-list-item v-for="item in seriesDaily" :key="item.name">
                <v-list-item-content>
                  {{item.data}}  {{item.name}}
                </v-list-item-content>
              </v-list-item>
            </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels> -->
    <v-card
      color="blue-grey darken-2"
      dark
      class="mx-auto my-8"
      max-width="100%"
    >
      <v-card-title> Species To Label</v-card-title>
      <!-- <v-card-subtitle>Soundscape labeled {{ nLabeled }}</v-card-subtitle> -->
      <v-btn class="mx-2" v-if="species != ''" @click="selectSpecies(species)"
        >Reload</v-btn
      >
      <v-overflow-btn
        @change="selectSpecies(species)"
        class="my-2"
        :items="targetList"
        label="Select Species"
        v-model="species"
      ></v-overflow-btn>
    </v-card>
    <v-container>
      <v-snackbar v-model="snackbar" timeout="1500" color="cyan" darken-2>
        No audio

        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar = false"> </v-btn>
        </template>
      </v-snackbar>
      <v-row v-for="(item, index) in hitsToLabel" :key="item.id">
        <v-card
          color="blue-grey darken-4"
          dark
          class="mx-auto my-8"
          width="100%"
        >
          <v-card-title
            >{{ item.cn }} {{ item.createdAt }} | score:{{ item.score }} |
            specSum:{{ item.specSum }}
            <v-spacer></v-spacer>
            <v-btn
              text
              v-if="isBat(item)"
              :href="'https://www.batcon.org/about-bats/bats-101/'"
              target="_blank"
              color="light-blue"
              >BCI</v-btn
            >
            <v-btn
              text
              v-if="!isBat(item)"
              :href="'https://ebird.org/species/' + item.spCode"
              target="_blank"
              color="light-blue"
              >eBird</v-btn
            >
          </v-card-title>
          <v-card-subtitle
            >{{ item.serial }}{{ item.name }} {{ item.detectionArray }} v{{
              item.version
            }}.lat:{{ item.lat }} .lon:{{ item.lon }}
          </v-card-subtitle>
          <v-card-subtitle>
            <Plotly
              :data="item.spectrogram"
              :layout="plotlyLayout"
              :display-mode-bar="false"
            ></Plotly>
          </v-card-subtitle>

          <v-card-actions>
            <v-btn v-if="item.wav" @click="play(item.wav)" color="#385F73"
              >Play</v-btn
            >
            <v-btn
              v-if="item.wav"
              @click="skip(item.wav, index)"
              color="#385F73"
              >Skip</v-btn
            >
            <v-slider
              class="px-3"
              v-model="playbackGain"
              prepend-icon="mdi-volume-high"
              min="40"
              max="200"
            ></v-slider>
            <v-btn
              text
              v-if="isBat(item)"
              :href="'https://www.batcon.org/about-bats/bats-101/'"
              target="_blank"
              >Learn More</v-btn
            >
            <v-btn
              text
              v-if="!isBat(item)"
              :href="'https://ebird.org/species/' + item.spCode"
              target="_blank"
              >Learn More</v-btn
            >
          </v-card-actions>
          <v-overflow-btn
            v-if="item.wav"
            @change="labelHit(item, index)"
            :background-color="item.classLabel != null ? 'accent' : 'darken'"
            class="my-2"
            :items="dropdown_class"
            label="Label"
            target="#label_all_sound"
            v-model="item.classLabel"
          ></v-overflow-btn>
        </v-card>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { API, Storage } from "aws-amplify";
import {
  hitsBySpeciesByDate,
  haikuboxByType,
  dailyCountBySerialByDate,
  labelBySerialByLabel,
  getDeviceState,
  labelByCnByLabel,
} from "../graphql/queries";
import { createLabeledData, updateHit } from "../graphql/mutations";
var moment = require("moment-timezone");

import { unmute } from "../unmute.min.js";
import { AudioContext, decodeAudioData } from "standardized-audio-context";
// const AudioContext = window.AudioContext || window.webkitAudioContext;
let globalAudioContext = null;
let globalGainNode = null;

// var fft = require('fft-js').fft;
// var fftUtil = require('fft-js').util;
var hann = [
  0.0, 3.77965773e-5, 1.51180595e-4, 3.4013491e-4, 6.04630957e-4, 9.44628746e-4,
  1.36007687e-3, 1.85091253e-3, 2.41706151e-3, 3.05843822e-3, 3.77494569e-3,
  4.56647559e-3, 5.43290826e-3, 6.3741127e-3, 7.38994662e-3, 8.48025644e-3,
  9.64487731e-3, 1.08836332e-2, 1.21963367e-2, 1.35827895e-2, 1.50427819e-2,
  1.65760932e-2, 1.81824916e-2, 1.98617342e-2, 2.16135671e-2, 2.34377255e-2,
  2.53339336e-2, 2.73019047e-2, 2.93413412e-2, 3.1451935e-2, 3.36333667e-2,
  3.58853068e-2, 3.82074146e-2, 4.05993391e-2, 4.30607187e-2, 4.55911813e-2,
  4.81903443e-2, 5.08578147e-2, 5.35931893e-2, 5.63960544e-2, 5.92659864e-2,
  6.22025514e-2, 6.52053053e-2, 6.82737943e-2, 7.14075543e-2, 7.46061116e-2,
  7.78689827e-2, 8.11956742e-2, 8.45856832e-2, 8.80384971e-2, 9.1553594e-2,
  9.51304424e-2, 9.87685015e-2, 1.02467221e-1, 1.06226043e-1, 1.10044397e-1,
  1.13921708e-1, 1.17857388e-1, 1.21850843e-1, 1.25901469e-1, 1.30008654e-1,
  1.34171776e-1, 1.38390206e-1, 1.42663307e-1, 1.46990432e-1, 1.51370928e-1,
  1.55804131e-1, 1.60289372e-1, 1.64825973e-1, 1.69413247e-1, 1.74050502e-1,
  1.78737036e-1, 1.8347214e-1, 1.88255099e-1, 1.9308519e-1, 1.97961681e-1,
  2.02883837e-1, 2.07850913e-1, 2.12862158e-1, 2.17916814e-1, 2.23014117e-1,
  2.28153297e-1, 2.33333576e-1, 2.38554171e-1, 2.43814294e-1, 2.49113148e-1,
  2.54449933e-1, 2.59823842e-1, 2.65234062e-1, 2.70679775e-1, 2.76160159e-1,
  2.81674384e-1, 2.87221617e-1, 2.92801019e-1, 2.98411747e-1, 3.04052952e-1,
  3.09723782e-1, 3.15423378e-1, 3.21150881e-1, 3.26905422e-1, 3.32686134e-1,
  3.38492141e-1, 3.44322565e-1, 3.50176526e-1, 3.56053138e-1, 3.61951513e-1,
  3.6787076e-1, 3.73809982e-1, 3.79768282e-1, 3.8574476e-1, 3.91738511e-1,
  3.97748631e-1, 4.03774209e-1, 4.09814335e-1, 4.15868096e-1, 4.21934577e-1,
  4.2801286e-1, 4.34102027e-1, 4.40201156e-1, 4.46309327e-1, 4.52425614e-1,
  4.58549094e-1, 4.64678841e-1, 4.70813928e-1, 4.76953428e-1, 4.83096412e-1,
  4.89241951e-1, 4.95389117e-1, 5.0153698e-1, 5.07684611e-1, 5.1383108e-1,
  5.19975458e-1, 5.26116815e-1, 5.32254225e-1, 5.38386758e-1, 5.44513487e-1,
  5.50633486e-1, 5.56745831e-1, 5.62849596e-1, 5.68943859e-1, 5.75027699e-1,
  5.81100196e-1, 5.87160431e-1, 5.93207489e-1, 5.99240456e-1, 6.05258418e-1,
  6.11260467e-1, 6.17245695e-1, 6.23213197e-1, 6.2916207e-1, 6.35091417e-1,
  6.41000339e-1, 6.46887944e-1, 6.52753341e-1, 6.58595644e-1, 6.6441397e-1,
  6.70207439e-1, 6.75975174e-1, 6.81716305e-1, 6.87429962e-1, 6.93115283e-1,
  6.98771407e-1, 7.0439748e-1, 7.09992651e-1, 7.15556073e-1, 7.21086907e-1,
  7.26584315e-1, 7.32047467e-1, 7.37475536e-1, 7.42867702e-1, 7.4822315e-1,
  7.5354107e-1, 7.58820659e-1, 7.64061117e-1, 7.69261652e-1, 7.74421479e-1,
  7.79539817e-1, 7.84615893e-1, 7.89648938e-1, 7.94638193e-1, 7.99582902e-1,
  8.04482319e-1, 8.09335702e-1, 8.14142317e-1, 8.18901439e-1, 8.23612347e-1,
  8.28274329e-1, 8.32886681e-1, 8.37448705e-1, 8.41959711e-1, 8.46419017e-1,
  8.5082595e-1, 8.55179843e-1, 8.59480037e-1, 8.63725883e-1, 8.67916738e-1,
  8.7205197e-1, 8.76130952e-1, 8.80153069e-1, 8.84117711e-1, 8.88024281e-1,
  8.91872186e-1, 8.95660845e-1, 8.99389686e-1, 9.03058145e-1, 9.06665667e-1,
  9.10211707e-1, 9.13695728e-1, 9.17117204e-1, 9.20475618e-1, 9.23770461e-1,
  9.27001237e-1, 9.30167455e-1, 9.33268638e-1, 9.36304317e-1, 9.39274033e-1,
  9.42177336e-1, 9.45013788e-1, 9.4778296e-1, 9.50484434e-1, 9.531178e-1,
  9.55682662e-1, 9.5817863e-1, 9.60605328e-1, 9.62962389e-1, 9.65249456e-1,
  9.67466184e-1, 9.69612237e-1, 9.71687291e-1, 9.73691033e-1, 9.75623159e-1,
  9.77483377e-1, 9.79271407e-1, 9.80986977e-1, 9.82629829e-1, 9.84199713e-1,
  9.85696393e-1, 9.87119643e-1, 9.88469246e-1, 9.89745e-1, 9.90946711e-1,
  9.92074198e-1, 9.9312729e-1, 9.94105827e-1, 9.95009663e-1, 9.9583866e-1,
  9.96592693e-1, 9.97271648e-1, 9.97875422e-1, 9.98403924e-1, 9.98857075e-1,
  9.99234805e-1, 9.99537058e-1, 9.99763787e-1, 9.99914959e-1, 9.99990551e-1,
  9.99990551e-1, 9.99914959e-1, 9.99763787e-1, 9.99537058e-1, 9.99234805e-1,
  9.98857075e-1, 9.98403924e-1, 9.97875422e-1, 9.97271648e-1, 9.96592693e-1,
  9.9583866e-1, 9.95009663e-1, 9.94105827e-1, 9.9312729e-1, 9.92074198e-1,
  9.90946711e-1, 9.89745e-1, 9.88469246e-1, 9.87119643e-1, 9.85696393e-1,
  9.84199713e-1, 9.82629829e-1, 9.80986977e-1, 9.79271407e-1, 9.77483377e-1,
  9.75623159e-1, 9.73691033e-1, 9.71687291e-1, 9.69612237e-1, 9.67466184e-1,
  9.65249456e-1, 9.62962389e-1, 9.60605328e-1, 9.5817863e-1, 9.55682662e-1,
  9.531178e-1, 9.50484434e-1, 9.4778296e-1, 9.45013788e-1, 9.42177336e-1,
  9.39274033e-1, 9.36304317e-1, 9.33268638e-1, 9.30167455e-1, 9.27001237e-1,
  9.23770461e-1, 9.20475618e-1, 9.17117204e-1, 9.13695728e-1, 9.10211707e-1,
  9.06665667e-1, 9.03058145e-1, 8.99389686e-1, 8.95660845e-1, 8.91872186e-1,
  8.88024281e-1, 8.84117711e-1, 8.80153069e-1, 8.76130952e-1, 8.7205197e-1,
  8.67916738e-1, 8.63725883e-1, 8.59480037e-1, 8.55179843e-1, 8.5082595e-1,
  8.46419017e-1, 8.41959711e-1, 8.37448705e-1, 8.32886681e-1, 8.28274329e-1,
  8.23612347e-1, 8.18901439e-1, 8.14142317e-1, 8.09335702e-1, 8.04482319e-1,
  7.99582902e-1, 7.94638193e-1, 7.89648938e-1, 7.84615893e-1, 7.79539817e-1,
  7.74421479e-1, 7.69261652e-1, 7.64061117e-1, 7.58820659e-1, 7.5354107e-1,
  7.4822315e-1, 7.42867702e-1, 7.37475536e-1, 7.32047467e-1, 7.26584315e-1,
  7.21086907e-1, 7.15556073e-1, 7.09992651e-1, 7.0439748e-1, 6.98771407e-1,
  6.93115283e-1, 6.87429962e-1, 6.81716305e-1, 6.75975174e-1, 6.70207439e-1,
  6.6441397e-1, 6.58595644e-1, 6.52753341e-1, 6.46887944e-1, 6.41000339e-1,
  6.35091417e-1, 6.2916207e-1, 6.23213197e-1, 6.17245695e-1, 6.11260467e-1,
  6.05258418e-1, 5.99240456e-1, 5.93207489e-1, 5.87160431e-1, 5.81100196e-1,
  5.75027699e-1, 5.68943859e-1, 5.62849596e-1, 5.56745831e-1, 5.50633486e-1,
  5.44513487e-1, 5.38386758e-1, 5.32254225e-1, 5.26116815e-1, 5.19975458e-1,
  5.1383108e-1, 5.07684611e-1, 5.0153698e-1, 4.95389117e-1, 4.89241951e-1,
  4.83096412e-1, 4.76953428e-1, 4.70813928e-1, 4.64678841e-1, 4.58549094e-1,
  4.52425614e-1, 4.46309327e-1, 4.40201156e-1, 4.34102027e-1, 4.2801286e-1,
  4.21934577e-1, 4.15868096e-1, 4.09814335e-1, 4.03774209e-1, 3.97748631e-1,
  3.91738511e-1, 3.8574476e-1, 3.79768282e-1, 3.73809982e-1, 3.6787076e-1,
  3.61951513e-1, 3.56053138e-1, 3.50176526e-1, 3.44322565e-1, 3.38492141e-1,
  3.32686134e-1, 3.26905422e-1, 3.21150881e-1, 3.15423378e-1, 3.09723782e-1,
  3.04052952e-1, 2.98411747e-1, 2.92801019e-1, 2.87221617e-1, 2.81674384e-1,
  2.76160159e-1, 2.70679775e-1, 2.65234062e-1, 2.59823842e-1, 2.54449933e-1,
  2.49113148e-1, 2.43814294e-1, 2.38554171e-1, 2.33333576e-1, 2.28153297e-1,
  2.23014117e-1, 2.17916814e-1, 2.12862158e-1, 2.07850913e-1, 2.02883837e-1,
  1.97961681e-1, 1.9308519e-1, 1.88255099e-1, 1.8347214e-1, 1.78737036e-1,
  1.74050502e-1, 1.69413247e-1, 1.64825973e-1, 1.60289372e-1, 1.55804131e-1,
  1.51370928e-1, 1.46990432e-1, 1.42663307e-1, 1.38390206e-1, 1.34171776e-1,
  1.30008654e-1, 1.25901469e-1, 1.21850843e-1, 1.17857388e-1, 1.13921708e-1,
  1.10044397e-1, 1.06226043e-1, 1.02467221e-1, 9.87685015e-2, 9.51304424e-2,
  9.1553594e-2, 8.80384971e-2, 8.45856832e-2, 8.11956742e-2, 7.78689827e-2,
  7.46061116e-2, 7.14075543e-2, 6.82737943e-2, 6.52053053e-2, 6.22025514e-2,
  5.92659864e-2, 5.63960544e-2, 5.35931893e-2, 5.08578147e-2, 4.81903443e-2,
  4.55911813e-2, 4.30607187e-2, 4.05993391e-2, 3.82074146e-2, 3.58853068e-2,
  3.36333667e-2, 3.1451935e-2, 2.93413412e-2, 2.73019047e-2, 2.53339336e-2,
  2.34377255e-2, 2.16135671e-2, 1.98617342e-2, 1.81824916e-2, 1.65760932e-2,
  1.50427819e-2, 1.35827895e-2, 1.21963367e-2, 1.08836332e-2, 9.64487731e-3,
  8.48025644e-3, 7.38994662e-3, 6.3741127e-3, 5.43290826e-3, 4.56647559e-3,
  3.77494569e-3, 3.05843822e-3, 2.41706151e-3, 1.85091253e-3, 1.36007687e-3,
  9.44628746e-4, 6.04630957e-4, 3.4013491e-4, 1.51180595e-4, 3.77965773e-5, 0.0,
];

import { FFT } from "dsp.js";
import { Plotly } from "vue-plotly";

export default {
  name: "Label",
  props: ["user"],
  created() {
    this.getHaikuboxList();
  },
  components: {
    Plotly,
  },
  mounted() {},
  data() {
    return {
      snackbar: false,
      showSpeciesList: false,
      playbackGain: 100,
      fftLength: 512,
      halfLength: 100,
      audioPlaying: false,
      pauseLabel: "Pause",
      file: "https://haikubox-media152750-prod.s3.amazonaws.com/public/Haikubox_1000000042361621/audio/bcnher_63_2020-10-29T20%3A13%3A37.660514Z.flac?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=ASIAW2VJULPB3WSHNY46%2F20201124%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20201124T191741Z&X-Amz-Expires=900&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEGQaCXVzLWVhc3QtMSJIMEYCIQCuYNQpdcHg1nsA5b6o3bDBmvHvLz%2F%2F%2B%2BFfouKpqAdHWQIhAIhokh8sbcz7z%2FNCr2djIWbT8fgODhHn%2FYA1VoDSeYntKs0ECNz%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEQAhoMNDY5NTgwOTI5OTg3Igxac6GaiIZ18YGgmRQqoQTtKlxZJJ%2FL5wyJxUfT2WIzJStAIgYgj6UwriyNG%2B2enc%2FPFsJ%2F3h1E9hfxEPqkbtiXm%2FhHM8dl7dKDfx5yz5mAJtgDZO%2Fw5iINeS%2F1utylwyIcsSqv6%2BLxF0eRw9pZLQZuMeAyqLalgc04CS3yAMYxC%2FcqJtN5yt7t1wuN23lRpoVz3vZ7Vaf9WUWpdNlEHE%2BMvK8ly3sI8kRlPMI0iPquPUSe1SMI0dAmDc8kfZRwYf165H8ze3KBR39yCWu2V8X5YkdTBTSLidCiz8r6ai2cQdyJEZfIY57AntGA6R5Mye9royV%2B0M8C%2BZn3iL33bdtzdrPNMAWPW1DlTM08Xrf%2ByWiXNGEAZvGIe1%2BusGnV9zQf7%2Bp57402gJePYnvXWC41LnuToRnvIUH15BmUiymvy54WNQ0Xo2tYZTiWT3BhKnxQ7PFTu%2FNOWk3z4K597QWy%2BBgI1D3mj9ShhLupj75eL8hQ5CQH3H7jQV0gBGt%2BW%2FNWPWq1%2FEBx4SszShzev7ysjgTkpa1dx%2Bz%2BgmRMamz3OU7k4Mnq99Wl9nB0esHtbYHLO8N5gm0M3DQ6xKXeBkM0Pf93RDS01vPvaP0UtpRFFqacyb%2BZDL%2F6my1oC3hVXu6HprXeuF87BNwrHpvx2yJm8D%2BGHum72uY0h%2FUGhqI9lr1DC%2Fc8m4hfgFQ95FumaTapcLxmPrnEXy%2FZ0oh%2FqKCBmgZ2F9OTS7AzAOwu23ubezDvtPX9BTqEArI4ZyljiBv59kWuuI0AW6RFdGhUmZALWesphIE0fdTXhZ4I3OD8eZJUZq7e%2FrobZzBCxcWYToo%2B2FjT59dOPpyYey6IzwCaeG5Na9jUYMSEr200FQciBvee29lvgS0ctxkuHeBFUNa9Js0PCOyv026qbfL4LemvYEZMuXQz22zRj6pd3xUICzJdMIe6%2F0AYQWoT4UKtc6dE8ddWFR20QghrRXL31g3DhDse1%2FBRg2r0a7%2F1ZqgBGPw4ErUj%2BiOalcBID86B0UeZh7Gpeyjj%2B0ASxU89lvGD668ILVn2NX%2BW90nrhi1Fnw9LQhhY%2FGEDZdmGBqs%2FvmvxIGpvs01qjs0oEw%2BL&X-Amz-Signature=5f72f16c613f40d550512d3b1c14ed33281dc8c16edb02f855aa33b1106bbc7a&X-Amz-SignedHeaders=host&x-amz-user-agent=aws-sdk-js-v3-%40aws-sdk%2Fclient-s3%2F1.0.0-gamma.8%20Mozilla%2F5.0%20%28Macintosh%3B%20Intel%20Mac%20OS%20X%2010_15_7%29%20AppleWebKit%2F537.36%20%28KHTML%2C%20like%20Gecko%29%20Chrome%2F86.0.4240.198%20Safari%2F537.36%20aws-amplify%2F3.5.3%20js&x-id=GetObject",
      dailyCounts: [],
      hitsToLabel: [],
      speciesList: [],
      haikuboxList: [],
      serialList: [],
      currentTimezone: "",
      labeledList: [],
      labelSearch: "Yes, song",
      nLabeled: 0,
      species: "",
      haikubox: "",
      haikuboxName: "",
      haikuboxSerial: "",
      dropdown_class: [
        // "Yes",
        "spot-Yes, song",
        "spot-Yes, call",
        // "spot-Yes, song, but more than 1 species",
        // "spot-Yes, call, but more than 1 species",
        // "spot-Wrong species",
        "spot-Not sure",
        // "spot-frog",
        // "spot-insect",
        // "spot-environmental",
        // "spot-Not a bird",
        // "Yes, but not sure about species",
        // "Yes, but wrong species",
        // "Something else",
        // "Not Sure",
        // "soundscape-bird",
        // "soundscape-no-bird",
        // "soundscape-human-bird",
        // "soundscape-human-no-bird",
        "Yes",
        "No",
        "No, it's a ...",
        // "Vehicle/Machine",
        // "Siren",
        // "Horn",
        // "Rain",
        // "Wind",
        // "Knock/Bang",
        // "Dog",
        // "Human",
        // "Gunshot",
        // "Insect",
        // "Squirrel",
        "Spring peeper",
        // "Greenhouse frog",
        // "Other frog",
        // "H2-Alarm",
        // "H2-Bang",
        // "H2-Beep",
        // "H2-Cat",
        // "H2-Chicken",
        // "H2-Child",
        "H2-Chime",
        // "H2-Construction",
        // "H2-Coyote",
        // "H2-Different species",
        // "H2-Dog",
        // "H2-Electrical",
        "H2-Engine",
        // "H2-Frog",
        // "H2-Gun",
        "H2-Human",
        "H2-Insect",
        "H2-Mechanical",
        // "H2-Music",
        // "H2-Noise",
        "H2-Phone",
        "H2-Power tool",
        "H2-Rain",
        "H2-Rooster",
        "H2-Scrape",
        "H2-Siren",
        "H2-Squeak",
        "H2-Squirrel",
        "H2-Train",
        "H2-Vehicle",
        "H2-Water",
        "H2-Wind",
        "H2-Skip"
      ],
      targetList: [
        // "Eurasian Blackbird",
        // "House Sparrow",
        // "European Robin",
        // "Common Redpoll",
        // "European Greenfinch",
        // "European Goldfinch",
        // "Eurasian Magpie",
        // "Common Wood-Pigeon",
        // "Redwing",
        // "Common House-Martin",
        // "Black Redstart",
        // "Great Tit",
        // "Eurasian Blue Tit",
        // "Common Chiffchaff",
        // "European Starling",
        // "Snow Bunting",
        // "Eurasian Collared-Dove",
        // "Eurasian Tree Sparrow",
        // "Tawny Owl",
        // "Barn Owl",
        // "Barred Owl",
        // "Eastern Screech-Owl",
        // "Northern Saw-whet Owl",
        // "Great Horned Owl",
        // "Northern Saw-whet Owl",
        // "Western Screech-Owl",
        // "Northern Pygmy-Owl",
        // "Long-eared Owl",
        // "Long-tailed Tit",
        // "Eurasian Blackcap",
        // "Great Spotted Woodpecker",
        // "Common Chaffinch",

        // "Cooper's Hawk",
        // "Bald Eagle",

        // "Belted Kingfisher",
        // "Broad-winged Hawk",
        // "Canada Goose",
        // "Common Grackle",
        // "Common Loon",
        // "Common Raven",
        // "Downy Woodpecker",
        
        // "Great Black-backed Gull",
        // "Great Blue Heron",
        // "Lesser Black-backed Gull",
        // "Mallard",
        
        // "Peregrine Falcon",
        // "Pileated Woodpecker",
        // "Red-breasted Nuthatch",
        // "Ring-billed Gull",
        // "Ring-necked Pheasant",
        // "Ruby-throated Hummingbird",
        // "Trumpeter Swan",
        // "White-breasted Nuthatch",
        // "White-throated Sparrow",
        // "Wild Turkey",
        // "Wood Duck",
        // "soundscape",
        // "Blue Jay",
        //  "Black-capped Chickadee",
        "Northern Cardinal",
        // "House Finch",
        // "Anna's Hummingbird",
        // "Tufted Titmouse",
        //  "American Crow",
        // "Red-bellied Woodpecker",
        // "Carolina Chickadee",
        //  "Yellow-rumped Warbler",
        // "Black Phoebe",
        //  "Fish Crow",
        //  "Downy Woodpecker",
        //  "White-breasted Nuthatch",
        //  "White-throated Sparrow",
        // "Engine",
        //  "Carolina Wren",
        // "Canada Goose",
        //  "Siren",
        //  "Hairy Woodpecker",
        // "Golden-crowned Kinglet",
        //  "American Tree Sparrow",
        // "American Goldfinch",
        // "House Sparrow",
        //  "Blue-gray Gnatcatcher",
        // "Northern Flicker",
        //  "Red-shouldered Hawk",
        // "Steller's Jay",
        // "Cedar Waxwing",
        //  "Dark-eyed Junco",
        //  "Palm Warbler",
        //  "European Starling",
        //  "Common Grackle",
        //  "Pileated Woodpecker",
        //  "Bewick's Wren",
        // "California Scrub-Jay",
        // "Dog",
        //  "Human non-vocal",
        // "Song Sparrow",
        // "White-crowned Sparrow",
        //  "California Towhee",
        // "Yellow-bellied Sapsucker",
        //  "Eastern Phoebe",
        //  "Chestnut-backed Chickadee",
        // "Gun",
        //  "Black-billed Magpie",
        // "American Robin",
        //  "Ruby-throated Hummingbird",
        //  "Eastern Bluebird",
        //  "Lesser Goldfinch",
        // "Power tools",
        //  "Gray Catbird",
        
        // "Mourning Dove",
        // "Spotted Towhee",
        //  "White-winged Dove",
        //  "Bushtit",
        // "Environmental",
        //  "Northern Mockingbird",
        //  "Eurasian Collared-Dove",
        //  "Red-breasted Nuthatch",
        // "Mountain Chickadee",
        // "Fireworks",
        // "Osprey",
        //  "Common Raven",
        // "Acorn Woodpecker",
        //  "Common Redpoll",
        //  "Oak Titmouse",
        //  "Eastern Wood-Pewee",
        //  "Red-tailed Hawk",
        //  "Golden-crowned Sparrow",
        //  "Pine Warbler",
        // "Eastern Towhee",
        //  "Pine Siskin",
        //  "Orange-crowned Warbler",
        //  "Nuttall's Woodpecker",
        //  "Killdeer",
        //  "Brown-headed Nuthatch",
        // "Ruby-crowned Kinglet",
        // "Brown-headed Cowbird",
        // "Rose-breasted Grosbeak",
        // "Belted Kingfisher",
        // "Hermit Thrush",
        // "Chimney Swift",
        // "Bald Eagle",
        // "Red-winged Blackbird",
        // "Wild Turkey",
        // "Townsend's Solitaire",
        // "Yellow-throated Warbler",
        // "Common Yellowthroat",
        // "Yellow-billed Cuckoo",
        // "White-eyed Vireo",
        // "Boat-tailed Grackle",
        // "Yellow-throated Vireo",
        // "Black-and-white Warbler",
        // "Woodhouse's Scrub-Jay",
        // "California Quail",
        // "Acadian Flycatcher",
        // "Summer Tanager",
        // "Cassin's Kingbird",
        // "American Kestrel",
        // "Western Bluebird",
        // "Sandhill Crane",
        // "Eastern Gray Squirrel",
        // "Human whistle",
        // "Ring-necked Pheasant",
        // "Northern Rough-winged Swallow",
        // "Costa's Hummingbird",
        // "Ovenbird",
        // "Brown Thrasher",
        // "Chipping Sparrow",
        // "Abert's Towhee",
        // "Broad-winged Hawk",
        // "Common Ground Dove",
        // "Red-eyed Vireo",
        // "Red-headed Woodpecker",
        // "American Pipit",
        // "Western Tanager",
        // "Rufous Hummingbird",
        // "Great Crested Flycatcher",
        // "Brewer's Blackbird",
        // "Wrentit",
        // "Brown Creeper",
        // "Cooper's Hawk",
        // "House Wren",
        // "Fox Sparrow",
        // "Savannah Sparrow",
        // "Pacific Wren",
        // "Trumpeter Swan",
        // "Common Loon",
        // "California Thrasher",
        // "Ladder-backed Woodpecker",
        // "Pacific-slope Flycatcher",
        // "Gray Kingbird",
        // "Black-bellied Whistling-Duck",
        // "Black-crested Titmouse",
        // "Purple Finch",
        // "Loggerhead Shrike",
        // "Say's Phoebe",
        // "Scarlet Tanager",
        // "Pygmy Nuthatch",
        // "Varied Thrush",
        // "Swamp Sparrow",
        // "Rusty Blackbird",
        // "Mississippi Kite",
        // "Winter Wren",
        // "Broad-tailed Hummingbird",
        // "Hooded Warbler",
        // "Golden-fronted Woodpecker",
        // "Northern Waterthrush",
        // "Wood Thrush",
        
        // "Blue-headed Vireo",
        // "Northern Parula",
        // "Eastern Meadowlark",
        // "Great-tailed Grackle",
        // "Indigo Bunting",
        // "Barn Swallow",
        // "Snow Goose",
        // "Buff-bellied Hummingbird",
        // "Painted Bunting",
        // "Cape May Warbler",
        // "Canyon Wren",
        // "Eastern Kingbird",
        // "Greater Roadrunner",
        // "Hutton's Vireo",
        // "Swallow-tailed Kite",
        // "Purple Martin",
        // "Magnolia Warbler",
        // "Yellow-breasted Chat",
        // "Violet-green Swallow",
        // "Swainson's Thrush",
        // "Golden Eagle",
        // "Hooded Oriole",
        // "Warbling Vireo",
        // "Rock Wren",
        // "Black-throated Gray Warbler",
        // "Northern Shrike",
        // "Peregrine Falcon",
        // "Black-throated Green Warbler",
        // "Least Flycatcher",
        // "Curve-billed Thrasher",
        // "Clark's Nutcracker",
        // "Wilson's Warbler",
        // "Verdin",
        // "Tree Swallow",
        // "Lincoln's Sparrow",
        
        // "Baltimore Oriole",
        // "Marsh Wren",
        // "Gambel's Quail",
        // "Bell's Sparrow",
        // "Evening Grosbeak",
        // "White-tailed Kite",
        // "Kentucky Warbler",
        // "Blue Grosbeak",
        // "Field Sparrow",
        // "Swainson's Hawk",
        // "Mountain Bluebird",
        // "Northern Bobwhite",
        // "Western Wood-Pewee",
        // "Prairie Warbler",
        // "Green-tailed Towhee",
        
        // "Gray-crowned Rosy-Finch",
        // "Red Crossbill",
        // "Common Nighthawk",
        // "Cassin's Finch",
        // "Northern Harrier",
        // "Monk Parakeet",
        // "Nanday Parakeet",
        // "Swainson's Warbler",
        // "Prothonotary Warbler",
        // "Lark Sparrow",
        // "Veery",
        // "Red-breasted Sapsucker",
        // "Sharp-shinned Hawk",
        // "Bachman's Sparrow",
        // "Orchard Oriole",
        // "Townsend's Warbler",
        // "Black-throated Blue Warbler",
        // "Canyon Towhee",
        // "Red-naped Sapsucker",
        // "Harris's Sparrow",
        // "Merlin",
        // "MacGillivray's Warbler",
        // "Western Meadowlark",
        // "Tricolored Blackbird",
        // "Black-chinned Hummingbird",
        // "Gila Woodpecker",
        // "Blackburnian Warbler",
        // "Bullock's Oriole",
        // "White-throated Swift",
        // "Long-billed Thrasher",
        // "Phainopepla",
        // "Tennessee Warbler",
        // "Black-headed Grosbeak",
        // "Cliff Swallow",
        // "American Woodcock",
        
        // "Yellow Warbler",
        // "Allen's Hummingbird",
        // "Hammond's Flycatcher",
        // "Arctic Warbler",
        // "Worm-eating Warbler",
        // "Horned Lark",
        // "Alder Flycatcher",
        // "Nashville Warbler",
        // "Willow Flycatcher",
        // "Juniper Titmouse",
        // "Pine Grosbeak",
        // "Ash-throated Flycatcher",
        // "Elegant Trogon",
        // "Green Kingfisher",
        // "Lazuli Bunting",
        // "Louisiana Waterthrush",
        // "Cactus Wren",
        // "Clay-colored Sparrow",
        // "Crissal Thrasher",
        // "Hermit Warbler",
        // "Lapland Longspur",
        // "Red-throated Loon",
        // "Black-throated Sparrow",
        // "Bobolink",
        // "Couch's Kingbird",
        // "Dusky-capped Flycatcher",
        // "Great Kiskadee",
        // "Green Jay",
        // "Lesser Nighthawk",
        // "Pinyon Jay",
        // "Ringed Kingfisher",
        // "Rivoli's Hummingbird",
        // "Sagebrush Sparrow",
        // "Tropical Kingbird",
        // "Western Kingbird",
        // "Yellow-bellied Flycatcher",
        // "Pacific Chorus Frog",
        // "Green Frog",
        // "Spring Peeper",
        // "Greenhouse Frog",
        // "Eastern Narrow-mouthed Toad",
        // "Chuck-will's-widow",
        // "Common True Katydid",
        // "Sword-bearing Conehead",
        // "Jumping Bush Cricket",
        // "Carolina Ground Cricket",
        // "Fall Field Cricket",
        // "Miogryllus saussurei",
        // "Pacific Chorus Frog",
        // "Snowy Tree Cricket",
        // "Columbian Trig",
        // "Common Virtuoso Katydid",
        // "Greater Angle-wing",
        // "Oblong-winged Katydid",
      ],
      labelTable: [],
      tableHeaders: [],
      falseDetectionHeaders: [],
      falseDetectionTable: [],
      plotlyLayout: {
        xaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: false,
          fixedrange: true,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: false,
          fixedrange: true,
        },
        margin: {
          l: 0,
          r: 0,
          b: 0,
          t: 0,
          pad: 4,
        },
        height: 240,
        hovermode: false,
      },
    };
  },
  methods: {
    isBat(itemOrSpCode) {
      if (typeof itemOrSpCode === 'object' && itemOrSpCode !== null) {
        return itemOrSpCode.group === 'bat';
      }
      return itemOrSpCode === 'batbatbat';
    },
    async getHaikuboxList() {
      var nextToken = null;
      var allHaikuboxes = [];
      do {
        const devices = await API.graphql({
          query: haikuboxByType,
          variables: { type: "haikubox", nextToken: nextToken },
        });
        nextToken = devices.data.haikuboxByType.nextToken;
        allHaikuboxes = allHaikuboxes.concat(devices.data.haikuboxByType.items);
        // console.log("allHaikuboxes", allHaikuboxes);
        // console.log("nextToken", nextToken);
      } while (nextToken != null);
      // console.log("Devices", this.devices);
      var serialList = [];
      var nameList = [];
      allHaikuboxes.forEach(function (element) {
        // console.log(element);
        //if ((element.owner != null) & tempList.includes(element.serial)) {
        if (element.owner != null) {
          if (element.name != null)
            nameList.push(element.serial + ":" + element.name);
          else {
            nameList.push(element.serial);
          }
          serialList.push(element.serial);
        }
      });
      this.devices = allHaikuboxes;
      this.haikuboxList = nameList;
      this.serialList = serialList;
      console.log(this.serialList);
      // this.serialList = [
      //   "Haikubox_10000000b5951071",
      //   "Haikubox_10000000afe87612",
      //   "Haikubox_100000005dd021ba",
      //   "Haikubox_1000000025913c0d",
      //   "Haikubox_10000000668d0e22",
      //   "Haikubox_100000002263c56e",
      //   "Haikubox_10000000e9435c55",
      //   "Haikubox_100000001160714a",
      //   "Haikubox_10000000020a01ad",
      //   "Haikubox_10000000b75d6ca7",
      //   "Haikubox_10000000eef044a3",
      //   "Haikubox_1000000088bf6ded",
      //   "Haikubox_1000000079e54129",
      //   "Haikubox_10000000dc9aadc6",
      //   "Haikubox_1000000032bbd3e2",
      //   "Haikubox_10000000cd32a2f3",
      //   "Haikubox_10000000ce373d69",
      //   "Haikubox_1000000035e90322",
      //   "Haikubox_3485188D7D44",
      //   "Haikubox_1000000012b37079",
      //   "Haikubox_10000000ef732633",
      //   "Haikubox_100000008d73911d",
      //   "Haikubox_348518973944",
      //   "Haikubox_100000007c1c7cd1",
      //   "Haikubox_1000000016dbd275",
      //   "Haikubox_1000000038006eab",
      //   "Haikubox_100000003b7f7ed9",
      //   "Haikubox_100000008b36b0d8",
      //   "Haikubox_10000000166b3b52",
      //   "Haikubox_100000007561eab4",
      //   "Haikubox_100000008cb335e8",
      //   "Haikubox_348518963E00",
      //   "Haikubox_34851897CB9C",
      //   "Haikubox_34851897246C",
      //   "Haikubox_348518979F78",
      //   "Haikubox_1000000091fab07c",
      //   "Haikubox_10000000bfdef646",
      //   "Haikubox_100000002b2675b2",
      //   "Haikubox_348518971EAC",
      //   "Haikubox_34851897CC0C",
      //   "Haikubox_10000000fd8f17da",
      //   "Haikubox_100000005034b990",
      //   "Haikubox_100000004d26ec78",
      //   "Haikubox_10000000d17dbb4f",
      //   "Haikubox_348518972C08",
      //   "Haikubox_10000000d3677778",
      //   "Haikubox_10000000cc4f6fd2",
      //   "Haikubox_100000009935b370",
      //   "Haikubox_100000002944e964",
      //   "Haikubox_10000000273810d0",
      //   "Haikubox_100000002ea953ec",
      //   "Haikubox_100000007bce31b0",
      //   "Haikubox_10000000f274f41f",
      //   "Haikubox_1000000019c6887b",
      //   "Haikubox_100000003d429712",
      //   "Haikubox_100000007f04987d",
      //   "Haikubox_10000000d5dbea53",
      //   "Haikubox_10000000f5393a80",
      //   "Haikubox_10000000f3d414ac",
      //   "Haikubox_100000000bad9f6f",
      //   "Haikubox_100000005aed9637",
      //   "Haikubox_1000000068d5b2b1",
      //   "Haikubox_100000008e43d7c3",
      //   "Haikubox_3485189762C8",
      //   "Haikubox_1000000063492601",
      //   "Haikubox_348518964A88",
      //   "Haikubox_348518973574",
      //   "Haikubox_10000000ccd644ef",
      //   "Haikubox_10000000d108c8cc",
      //   "Haikubox_100000007853cbce",
      //   "Haikubox_1000000061f1b65f",
      //   "Haikubox_100000000ee5163e",
      //   "Haikubox_10000000b7f7332f",
      //   "Haikubox_10000000f8f6a5c2",
      //   "Haikubox_100000006c1fbf14",
      //   "Haikubox_348518977A78",
      //   "Haikubox_100000001ebe636a",
      //   "Haikubox_100000009825df89",
      //   "Haikubox_10000000a2c206d7",
      //   "Haikubox_100000009aec770c"
      // ];
    },
    sumField(key) {
      // sum data in give key (property)
      return this.labelTable.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumFalseDetection(key) {
      // sum data in give key (property)
      return this.falseDetectionTable.reduce((a, b) => a + (b[key] || 0), 0);
    },
    async getStats() {
      // get stats
      // query labeledData for summary of what's been done
      var nextToken = null;
      var speciesCount = 0;
      var allLabelsBySpecies = {};
      var tableLabeled = [];
      this.tableHeaders = [
        {
          text: "Species",
          align: "start",
          sortable: false,
          value: "name",
        },
        // { text: this.labelSearch, value: "count", sortable: true },
      ];
      for (var i = 0; i < this.dropdown_class.length; i++) {
        var labelHeader = {
          text: this.dropdown_class[i],
          value: this.dropdown_class[i],
        };
        this.tableHeaders.push(labelHeader);
      }

      // loop through species
      for (
        var queryIndex = 0;
        queryIndex < this.targetList.length;
        queryIndex++
      ) {
        allLabelsBySpecies["name"] = this.targetList[queryIndex];
        var haikuSerialList = [];
        // loop through labels
        for (i = 0; i < this.dropdown_class.length; i++) {
          // search hit table for labeled sounds
          // console.log("cn", this.targetList[queryIndex], this.dropdown_class[i]);
          do {
            const labels = await API.graphql({
              query: labelByCnByLabel,
              variables: {
                cn: this.targetList[queryIndex],
                label: { eq: this.dropdown_class[i] },
                nextToken: nextToken,
              },
            });
            nextToken = labels.data.labelByCnByLabel.nextToken;
            speciesCount += labels.data.labelByCnByLabel.items.length;
            for (var j=0; j<labels.data.labelByCnByLabel.items.length; j++){
              let curSerial = labels.data.labelByCnByLabel.items[j].serial;
              if (!haikuSerialList.includes(curSerial)){
                haikuSerialList.push(curSerial);
              }
            }
            
            console.log(this.dropdown_class[i], "speciesCount", speciesCount);
            console.log(
              "Page",
              this.targetList[queryIndex],
              labels.data.labelByCnByLabel.items
            );
          } while (nextToken != null);
          console.log("speciesCount", speciesCount);
          console.log("Serial List", haikuSerialList);
          //console.log(this.targetList[queryIndex], speciesCount);
          allLabelsBySpecies[this.dropdown_class[i]] = speciesCount;
          speciesCount = 0;
        }
        tableLabeled.push(allLabelsBySpecies);
        allLabelsBySpecies = {};
        this.labelTable = tableLabeled;
      }
      // console.log("Table", this.labelTable);
      // console.log("Headers", this.tableHeaders);
    },
    async getFalseDetectionStats() {
      // query labeledData for summary of what's been done
      var nextToken = null;
      var labelCount = 0;
      var allLabelsByLabel = {};
      var tableLabeled = [];
      this.falseDetectionHeaders = [
        {
          text: "Haikubox",
          align: "start",
          sortable: false,
          value: "name",
        },
      ];
      for (
        queryIndex = 0;
        queryIndex < this.dropdown_class.length;
        queryIndex++
      ) {
        var labelHeader = {
          text: this.dropdown_class[queryIndex],
          value: this.dropdown_class[queryIndex],
        };
        this.falseDetectionHeaders.push(labelHeader);
      }

      for (
        var haikuIndex = 0;
        haikuIndex < this.haikuboxList.length;
        haikuIndex++
      ) {
        allLabelsByLabel["name"] = this.haikuboxList[haikuIndex];
        for (
          var queryIndex = 0;
          queryIndex < this.dropdown_class.length;
          queryIndex++
        ) {
          // console.log("query", this.dropdown_class[queryIndex]);
          do {
            const labels = await API.graphql({
              query: labelBySerialByLabel,
              variables: {
                serial: this.haikuboxList[haikuIndex].slice(0, 25),
                label: { eq: this.dropdown_class[queryIndex] },
                nextToken: nextToken,
              },
            });
            nextToken = labels.data.labelBySerialByLabel.nextToken;
            labelCount += labels.data.labelBySerialByLabel.items.length;
            // console.log("Page", this.haikuboxList[haikuIndex], this.dropdown_class[queryIndex], labels.data.labelBySerialByLabel.items);
          } while (nextToken != null);
          allLabelsByLabel[this.dropdown_class[queryIndex]] = labelCount;
          labelCount = 0;
        }
        tableLabeled.push(allLabelsByLabel);
        allLabelsByLabel = {};
        this.falseDetectionTable = tableLabeled;
      }
      // console.log("FD Table", this.falseDetectionTable);
      // console.log("FD Headers", this.tableHeaders);
    },
    async selectHaikubox(haikubox) {
      var index = this.haikuboxList.indexOf(haikubox);
      var serial = this.serialList[index];
      console.log("index serial", index, serial);
      // const deviceInfo = await API.graphql({
      //   query: haikuboxBySerial,
      //   variables: { serial: serial },
      // });
      // console.log("device info", deviceInfo.data.haikuboxBySerial.items);
      this.haikuboxName = serial;
      this.haikuboxSerial = serial;
      this.showSpeciesList = true;
      this.species = "";
      this.nLabeled = 0;
      this.hitsToLabel = [];

      const deviceState = await API.graphql({
        query: getDeviceState,
        variables: { id: serial },
      });
      var clickedDevice = deviceState.data.getDeviceState;
      this.currentTimezone = clickedDevice.timezone;
      // console.log(this.currentTimezone);
    },
    async selectSpecies(species) {
      this.species = species;

      // // query hit labels for summary of what's been done
      // var nextToken = null;
      // var allLabels = [];
      // do {
      //   const labels = await API.graphql({
      //     query: hitsBySpecies,
      //     variables: {
      //       serial: this.haikuboxSerial,
      //       cn: { eq: this.species },
      //       filter: {label: { beginsWith: "soundscape-" }},
      //       nextToken: nextToken,
      //     },
      //   });
      //   nextToken = labels.data.hitsBySpecies.nextToken;
      //   allLabels = allLabels.concat(labels.data.hitsBySpecies.items);
      // } while (nextToken != null);
      // // console.log("labeled", allLabels);
      // this.labeledList = allLabels;
      // this.nLabeled = this.labeledList.length;

      this.hitsToLabel = [];
      // query species for unlabeled hits
      var scoreThreshold = 0.4;
      if (species === "soundscape") {
        scoreThreshold = 0;
      }
      const filterArg = {
        label: { attributeExists: false },
        wav: { ne: "" },
        score: { ge: scoreThreshold },
        specSum: {ge: 100}
        // lon: {lt: -20},
        // version: { gt: 1.37 },
      };
      // console.log(filterArg);
      // console.log("Haikubox", this.haikuboxSerial);

      // load samples for selected haikubox
      var indexList = [];
      // for (var i = 0; i < this.serialList.length; i++) {
      for (var i = 0; i < 20; i++) {
        let randomIndex = Math.floor(Math.random() * this.serialList.length);
        while (indexList.includes(randomIndex)) {
          randomIndex = Math.floor(Math.random() * this.serialList.length);
        }
        indexList.push(randomIndex);
        // console.log('index', randomIndex, this.serialList.length);
        const hits = await API.graphql({
          query: hitsBySpeciesByDate,
          variables: {
            serial: this.serialList[randomIndex],
            cnDt: { beginsWith: { cn: this.species } },
            filter: filterArg,
            limit: 20,
          },
        });
        console.log("query", this.species, this.haikuboxSerial, hits);
        if (hits.data.hitsBySpeciesByDate.items[0]) {
          // hits.data.hitsBySpeciesByDate.items[0].name = this.haikuboxList[i];
          //  hits.data.hitsBySpeciesByDate.items[0].name = this.haikuboxList[i];

          // Look for times between 00:00Z and 09:00Z

          var items = hits.data.hitsBySpeciesByDate.items;
          for (var j = 0; j < items.length; j++){
            var dateTime = new Date(items[j].createdAt);
            var hour = dateTime.getUTCHours();
            var month = dateTime.getMonth();
            if ((hour >= 1 && hour < 9) && (month >=2 && month <=5) && (items[j].type=='haikubox2') && (items[j].lon > -92)) {
                console.log(hour, month, items[j]);
                this.hitsToLabel.push(items[j]);
              }
          }
          // this.hitsToLabel = this.hitsToLabel.concat(
          //   hits.data.hitsBySpeciesByDate.items
          // );
          // console.log(this.serialList[i], this.haikuboxList[i], hits.data.hitsBySpeciesByDate.items[0]);
        }
        if (this.hitsToLabel.length >= 60) break;
      }

      // console.log("hitsToLabel", this.hitsToLabel);
      // this.hitsToLabel = hits.data.hitsBySpecies.items;

      for (i = 0; i < this.hitsToLabel.length; i++) {
        this.spectrogram(i, this.hitsToLabel[i].wav);
        // var timeString = moment
        //   .utc(this.hitsToLabel[i].createdAt)
        //   .tz(this.currentTimezone)
        //   .format("MMM D h:mm:ss a");
        // this.hitsToLabel[i].localTime = timeString;
      }
    },
    labelHit(item, index) {
      // console.log(item, index);
      if (!item.classLabel) return;
      const serial = item.serial;
      const dt = item.dt;
      const group = item.group;
      const cn = item.cn;
      const sn = item.sn;
      const spCode = item.spCode;
      const wav = item.wav;
      const labeledBy = this.user;
      const label = item.classLabel;
      const score = item.score;
      const lat = item.lat;
      const lon = item.lon;
      const labeledData = {
        serial,
        dt,
        group,
        cn,
        sn,
        spCode,
        wav,
        labeledBy,
        label,
        score,
        lat,
        lon,
      };
      API.graphql({
        query: createLabeledData,
        variables: { input: labeledData },
      });

      let id = item.id;
      if (item.id.slice(0, 8) == "Haikubox") id = item.id.slice(0, -1);
      const updateHitData = {
        id,
        labeledBy,
        label,
      };
      // console.log("updateHitData", updateHitData);
      API.graphql({
        query: updateHit,
        variables: { input: updateHitData },
      });
      this.hitsToLabel.splice(index, 1);
      if (label === "Yes, correct species") this.nLabeled += 1;
    },
    skip(audioFile, index) {
      this.hitsToLabel.splice(index, 1);
    },
    initAudioContext() {
      if (globalAudioContext == null) {
        const isIOS = /iPhone|iPod|iPad/.test(navigator.userAgent);
        if (isIOS) {
          globalAudioContext = new AudioContext();
          // Note: audioContext, allowBackgroundPlayback, forceIOSBehavior
          unmute(globalAudioContext, false, false);
        } else {
          globalAudioContext = new AudioContext();
        }
        globalGainNode = globalAudioContext.createGain();
        globalGainNode.gain.value = this.playbackGain; // Set initial volume level
        globalGainNode.connect(globalAudioContext.destination);
      }
    },
    async play(audioFile) {
      console.log("playFile", audioFile);
      this.initAudioContext();

      if (globalAudioContext.state === "suspended") {
        globalAudioContext.resume();
      }
      globalGainNode.gain.value = this.playbackGain;

      var audioUrl = await Storage.get(audioFile);
      const response = await fetch(audioUrl);
      const arrayBuffer = await response.arrayBuffer();
      const audioBuffer = await globalAudioContext.decodeAudioData(arrayBuffer);

      const sampleSource = globalAudioContext.createBufferSource();
      sampleSource.buffer = audioBuffer;
      sampleSource.connect(globalGainNode);
      sampleSource.start(0);
    },
    spectrogram(index, audioFile) {
      // console.log("Spectrogram", audioFile);
      this.initAudioContext();

      // if (!context) {
      //   if (context.state === "suspended") {
      //     context.resume();
      //   }
      // }

      async function getFile(audioContext, filepath) {
        // webkit audio decodeAudioData does not work in Safari
        // const response = await fetch(filepath);
        // const arrayBuffer = await response.arrayBuffer();
        // const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        // return audioBuffer;

        // standardized-audio-context from npm
        const nativeAudioContext = new AudioContext();
        const response = await fetch(filepath);
        const arrayBuffer = await response.arrayBuffer();
        const audioBuffer = await decodeAudioData(
          nativeAudioContext,
          arrayBuffer
        );
        return audioBuffer;
      }

      async function setupSample(filePath) {
        var context = new AudioContext();
        const sample = await getFile(context, filePath);

        return sample;
      }

      function linear2Decibel(value) {
        var dB = 20 * Math.log10(value);
        return dB;
      }

      Storage.get(audioFile)
        .then(
          (result) => {
            // console.log("Storage get", result);

            setupSample(result)
              .then((sample) => {
                // console.log("sample", sample);
                let signal = sample.getChannelData(0);
                // console.log("raw", signal);

                // calculate spectrogram
                // let ts = 0;
                let overlap = 0.0;
                let fftLength = this.fftLength;
                let halfLength = this.halfLength;
                let offset = Math.floor(fftLength * (1.0 - overlap));
                // console.log("offset", offset);
                let fft = new FFT(fftLength, 44100);
                var spectrogramArray = [];
                for (var x = 0; x < sample.length - fftLength; x += offset) {
                  var chunk = signal.slice(x, x + fftLength);
                  for (var i = 0; i < fftLength; i++) {
                    chunk[i] = chunk[i] * hann[i];
                  }
                  fft.forward(chunk);
                  chunk = fft.spectrum.slice(0, halfLength);
                  // console.log("fft", chunk);
                  var dBmag = chunk.map(linear2Decibel);
                  // console.log("dB", dBmag);
                  spectrogramArray.push(...dBmag);
                }

                // console.log("linear spec", spectrogramArray);

                // arrange spectrogram for Plotly
                var spectrogramData = [];
                for (i = 0; i < halfLength; i++) {
                  // grab one element every halfLength points
                  var arr = spectrogramArray.filter(function (value, j) {
                    return j % halfLength == 0;
                  });
                  spectrogramData.push(arr);
                  spectrogramArray.shift(); // remove first element
                }

                var tempSpec = [
                  {
                    z: spectrogramData,
                    type: "heatmap",
                    showscale: false,
                    zmid: -90,
                  },
                ];

                // console.log('tempSpec', tempSpec);
                this.hitsToLabel[index].spectrogram = tempSpec;
                this.hitsToLabel[index].id += 1; // update image on page
              })
              .catch((err) => {
                console.log(err);
                console.log("No audio", audioFile);
                // console.log("Delete index", index);
                this.snackbar = true;
                return false;
              });
          },
          (reason) => {
            // rejection
            console.log("Can't play ", reason);
          }
        )
        .catch((err) => {
          console.log(err);
        });
    },
    async getDailyCount() {
      this.species = null;
      this.labeledList = [];
      this.haikuboxSerial = this.haikubox.slice(0, 25);
      let lastMonthDate = moment.utc().subtract(90, "days").format();
      const filterArg = {
        serial: this.haikuboxSerial,
        date: { gt: lastMonthDate },
      };
      const dailyCounts = await API.graphql({
        query: dailyCountBySerialByDate,
        variables: filterArg,
      });
      this.dailyCounts = dailyCounts.data.dailyCountBySerialByDate.items;
      // // console.log("Daily Counts Query", this.dailyCounts);
      let speciesList = [];
      let dateList = [];
      let entry = {};
      for (entry in this.dailyCounts) {
        speciesList.push(...this.dailyCounts[entry].cn);
        dateList.push(this.dailyCounts[entry].date);
      }

      // clear chart if no data
      if (speciesList.length == 0) {
        // console.log("no data");
        this.seriesDaily = [];
        this.chartOptions = {
          xaxis: {
            categories: [],
          },
        };
        return;
      }

      // Create date array in case dates with no results
      let minDate = dateList.reduce(function (a, b) {
        return a < b ? a : b;
      });
      let maxDate = dateList.reduce(function (a, b) {
        return a > b ? a : b;
      });

      function getDates(startDate, stopDate) {
        var dateArray = [];
        var currentDate = moment(startDate);
        stopDate = moment(stopDate);
        while (currentDate <= stopDate) {
          dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
          currentDate = moment(currentDate).add(1, "days");
        }
        return dateArray;
      }
      let dateArr = getDates(minDate, maxDate);

      // Remove duplicates from species list
      speciesList = Array.from(new Set(speciesList));
      // // console.log("dateArr", dateArr);
      // // console.log("speciesList", speciesList);
      let nrows = speciesList.length;
      let ncolumns = dateArr.length;

      // create array with zeros for species counts
      let countArray = new Array(nrows);
      for (let i = 0; i < countArray.length; i++) {
        countArray[i] = new Array(ncolumns).fill(0);
      }
      // // console.log(countArray);

      // loop through all days
      // for each entry figure out date index
      // loop through each species for that date and put in array
      for (entry in this.dailyCounts) {
        let newDate = moment(this.dailyCounts[entry].date).format("YYYY-MM-DD");
        let dateIndex = dateArr.indexOf(newDate);
        let species = {};
        for (species in this.dailyCounts[entry].cn) {
          //// console.log("species", species);
          let speciesIndex = speciesList.indexOf(
            this.dailyCounts[entry].cn[species]
          );
          // // console.log(dateIndex, speciesIndex);
          countArray[speciesIndex][dateIndex] =
            this.dailyCounts[entry].count[species];
        }
      }

      function getSum(total, num) {
        return total + num;
      }
      for (let i = 0; i < nrows; i++) {
        countArray[i] = countArray[i].reduce(getSum);
      }

      this.seriesDaily = [];
      this.speciesList = [];
      var sortOrder = Array.from(Array(speciesList.length).keys()).sort(
        (a, b) =>
          countArray[a] > countArray[b]
            ? -1
            : (countArray[b] > countArray[a]) | 0
      );

      for (let i = 0; i < nrows; i++) {
        this.seriesDaily.push({
          name: speciesList[sortOrder[i]],
          data: countArray[sortOrder[i]],
        });
        this.speciesList.push(speciesList[sortOrder[i]]);
      }

      // console.log("dailyCount", this.seriesDaily);
    },
  },
};
</script>

<style>
</style>